import { defineStore } from 'pinia'
import { ref } from 'vue'

export const usePlatformStore = defineStore('platform', () => {
  const isSidebarCollapsed = ref(false)
  const locale = ref('en-US')

  const setSidebarCollapse = (value: boolean) => {
    isSidebarCollapsed.value = value
  }

  const toggleSidebarCollapse = () => {
    isSidebarCollapsed.value = !isSidebarCollapsed.value
  }

  const setLocale = (value: string) => {
    locale.value = value
  }

  return {
    isSidebarCollapsed,
    setSidebarCollapse,
    toggleSidebarCollapse,
    locale,
    setLocale,
  }
})
